import {toggleSlide} from "../modules/helpers";

export class WarningService {
    constructor() {
        this.duplcicatesWarningBox = $("#document-duplicates");
        this.contractorNotCompleateWarningBox = $("#contractor-not-complete-warning");
        this.contractorJstWarningBox = $("#contractor-jst-warning");
        this.contractorGvWarningBox = $("#contractor-gv-warning");
        this.contractorNotCompleateErrorBox = $("#contractor-not-complete-error");
        this.contractorJstErrorBox = $("#contractor-jst-error");
        this.contractorGvErrorBox = $("#contractor-gv-error");
        this.transferSplitPaymentWarningBox = $("#transfer-split-payment-id-number-mismatch");
        this.currencyMismatchWarningBox = $("#currency-mismatch");
        this.currencyMismatchBlockingWarningBox = $("#currency-mismatch-blocking");
        this.buyerViesWarningBox = $("div.buyer-vies-warning");
        this.vendorViesWarningBox = $("div.vendor-vies-warning");
        this.vatExemptWarningBox = $("div.vat-exempt");
        this.euMeansOfTransportPurchaseWarningBox = $("div.eu_means_of_transport_purchase");
        this.trilateralTransactionWarningBox = $("div.trilateral_transaction");
        this.advancePaymentsAmountExceededWarningBox = $("#advance-payments-amount-exceeded");
        this.advancePaymentsPlAmountExceededWarningBox = $("#advance-pl-payments-amount-exceeded");
        this.settlementHasBeenMadeSuggestWarningBox = $("#settlement-has-been-made-suggest-alert");
        this.advanceInvoicesKsefNumber = $("#ksef-advance-invoices")
    }

    get hasVisiblePreventSubmitWarning() {
        let hasVisibleWarnings = false;

        $("div.panel-warning:visible, div.panel-danger:visible").each((index, element) => {
            if ($(element).data("allows-submit") === 0) {
                hasVisibleWarnings = true;
                return false;
            }
        });

        return hasVisibleWarnings;
    }

    toggleDuplicatesWarning(visible = true) {
        toggleSlide(this.duplcicatesWarningBox, visible);
    }

    toggleContractorCompleteWarning(visible = true) {
        toggleSlide(this.contractorNotCompleateWarningBox, visible);
    }

    toggleContractorJstWarning(visible = true) {
        toggleSlide(this.contractorJstWarningBox, visible);
    }
    toggleContractorGvWarning(visible = true) {
        toggleSlide(this.contractorGvWarningBox, visible);
    }
    toggleContractorCompleteError(visible = true) {
        toggleSlide(this.contractorNotCompleateErrorBox, visible);
    }
    toggleContractorJstError(visible = true) {
        toggleSlide(this.contractorJstErrorBox, visible);
    }
    toggleContractorGvError(visible = true) {
        toggleSlide(this.contractorGvErrorBox, visible);
    }

    toggleTransferSplitPaymentWarning(visible = true) {
        toggleSlide(this.transferSplitPaymentWarningBox, visible);
    }

    toggleCurrencyMismatchWarningBox(visible = true) {
        toggleSlide(this.currencyMismatchWarningBox, visible);
    }

    toggleCurrencyMismatchBlockingWarningBox(visible = true) {
        toggleSlide(this.currencyMismatchBlockingWarningBox, visible);
    }

    toggleBuyerViesWarningBox(visible = true) {
        toggleSlide(this.buyerViesWarningBox, visible);
    }

    toggleVendorViesWarningBox(visible = true) {
        toggleSlide(this.vendorViesWarningBox, visible);
    }



    toggleTrilateralTransactionWarningBoxWarningBox(visible = true) {
        toggleSlide(this.trilateralTransactionWarningBox, visible);
    }

    toggleAdvancePaymentsAmountExceededWarningBox(visible = true) {
        toggleSlide(this.advancePaymentsAmountExceededWarningBox, visible);
    }

    toggleAdvancePlPaymentsAmountExceededWarningBox(visible = true) {
        toggleSlide(this.advancePaymentsPlAmountExceededWarningBox, visible);
    }

    toggleSettlementHasBeenMadeSuggestWarningBox(visible = true) {
        toggleSlide(this.settlementHasBeenMadeSuggestWarningBox, visible);
    }

    showAdvancePaymentKsefAlert(documents) {
        let messages = documents
            .map(obj => obj.ksef_info)
            .filter(info => info); // usunie null/undefined/puste stringi

        let uniqueMessages = [...new Set(messages)];

        let content = uniqueMessages.join("<br>");
        this.advanceInvoicesKsefNumber.find('p.mb-0').html(content);
    }
    showPreviousPaymentKsefAlert(documents){
        let messages = documents.map(obj => obj.ksef_info);

        // składamy je w string rozdzielony <br>
        let content = messages.join("<br>");
        console.log('contante:', content)
        // wstawiamy do <p class="mb-0"> w panelu
        $('#ksef-advance-invoices-previous').find('p.mb-0').html(content);
    }


}
